<template>
	<div :class="reply">
		<div class="flex-title">
			快捷回复
			<div>
				<el-tooltip class="item" effect="dark" content="添加修改快捷回复" placement="top-start">
					<i class="iconfont icon-setting setting" id="addQuick" @click="AddQuick"></i>
				</el-tooltip>
				<i class="el-icon-close close" @click="close"></i>
			</div>
		</div>
		<div class="tablist">
			<div @click="switchto(0)" :class="tabclass1">个人库</div>
			<div @click="switchto(1)" :class="tabclass2">公共库</div>
		</div>
		<div class="tabcontent">
			<div v-if="tabclass1=='on'" class style="height: calc(100vh - 165px);overflow: auto;" > 
				<!-- <el-input placeholder="搜索快捷回复" v-model="tagQuery1">
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
				<div
					class="words"
					v-for="(item,index) in tag1search"
					v-if="tagQuery1!==''"
					@click="onSelected(item)"
				>
					<span>{{item.keyWord}}</span>
					{{item.content}}
				</div>
				<div class="list" v-for="(item,index) in quickList.filter(d=>d.type!=0)" v-if="tagQuery1==''">
					<div class="title" @click="tag1Click(index)">
						<i
							:class="tag1Selected.findIndex(d=>d.index==index && d.selected==true)>-1?'el-icon-caret-bottom':'el-icon-caret-right'"
						></i>
						{{item.groupName}}
					</div>
					<el-collapse-transition style>
						<div v-if="tag1Selected.findIndex(d=>d.index==index && d.selected==true)>-1">
							<div class="words" v-for="(ele,index) in item.quickReplyList" @click="onSelected(ele)">
								<span>{{ele.keyWord}}</span>
								{{ele.content}}
							</div>
						</div>
					</el-collapse-transition>
				</div>-->
				<el-tree
					@node-click="NodeClisk"
					:data="quickTree"
					node-key="id"
					:expand-on-click-node="false"
					:render-content="renderContent"
					v-loading="fetchLoding"
					:default-expanded-keys="[0]"
				></el-tree>
			</div>
			<div v-if="tabclass2=='on'" @click="getQuickGroups(0)" style="height: calc(100vh - 165px);overflow: auto;" >
				<el-tree
					@node-click="NodeClisk"
					:data="quickTree"
					node-key="id"
					:expand-on-click-node="false"
					:render-content="renderContent"
					v-loading="fetchLoding"
					:default-expanded-keys="[0]"
				></el-tree>
				<!-- <el-input placeholder="搜索快捷回复" v-model="tagQuery2">
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
				<div
					class="words"
					v-for="(item,index) in tag2search"
					v-if="tagQuery2!==''"
					@click="onSelected(item)"
				>
					<span>{{item.keyWord}}</span>
					{{item.content}}
				</div>
				<div class="list" v-for="(item,index) in quickList.filter(d=>d.type==0)" v-if="tagQuery2==''">
					<div class="title" @click="tag2Click(index)">
						<i
							:class="tag2Selected.findIndex(d=>d.index==index && d.selected==true)>-1?'el-icon-caret-bottom':'el-icon-caret-right'"
						></i>
						{{item.groupName}}
					</div>
					<el-collapse-transition>
						<div v-if="tag2Selected.findIndex(d=>d.index==index && d.selected==true)>-1">
							<div class="words" v-for="(ele,index) in item.quickReplyList" @click="onSelected(ele)">
								<span>{{ele.keyWord}}</span>
								{{ele.content}}
							</div>
						</div>
					</el-collapse-transition>
				</div>-->
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'quickReply',
	props: [],
	data() {
		const data = [
			{
				id: 1,
				label: '一级 1',
				children: [
					{
						id: 4,
						label: '二级 1-1',
						children: [
							{
								id: 9,
								label: '三级 1-1-1'
							},
							{
								id: 10,
								label: '三级 1-1-2'
							}
						]
					}
				]
			},
			{
				id: 2,
				label: '一级 2',
				children: [
					{
						id: 5,
						label: '二级 2-1'
					},
					{
						id: 6,
						label: '二级 2-2'
					}
				]
			},
			{
				id: 3,
				label: '一级 3',
				children: [
					{
						id: 7,
						label: '二级 3-1'
					},
					{
						id: 8,
						label: '二级 3-2'
					}
				]
			}
		]
		return {
			reply: 'reply',
			show5: false,
			tagQuery2: '',
			tagQuery1: '',
			tabclass1: 'on',
			tabclass2: '',
			common_words: [
				{
					title: '常用语 客服不在请稍后咨询'
				},
				{
					title: '常用语2'
				},
				{
					title: '常用语3'
				}
			],
			tag1Selected: [
				{
					index: 0,
					selected: false
				}
			],
			tag2Selected: [
				{
					index: 0,
					selected: false
				}
			],
			tag2search: [],
			tag1search: [],
			data: JSON.parse(JSON.stringify(data)),
			quickTree: [],
			quickTreeSys: [],
			typeId: 1,
			fetchLoding: false
		}
	},
	props: {
		quickList: {
			type: Array,
			default: () => []
		},
		quickQuery: {
			type: Array,
			default: () => []
		},
		isShow: {
			type: String,
			default: 'reply'
		}
	},
	watch: {
		tagQuery2: function(val) {
			console.log(this.quickQuery)
			var str = this.quickQuery.filter(
				d =>
					d.type == 0 &&
					(!val || (d.keyWord && d.keyWord.includes(val)))
			)
			this.tag2search = str
		},
		tagQuery1: function(val) {
			var str = this.quickQuery.filter(
				d =>
					d.type != 0 &&
					(!val || (d.keyWord && d.keyWord.includes(val)))
			)
			this.tag1search = str
			console.debug(this.tag1search)
		},
		isShow: function(val) {
			this.reply = val
		}
	},
	created: function() {
		this.getQuickGroups(1)
	},
	methods: {
		getQuickGroups(typeid) {
			let vm = this
			vm.$emit('TagType', typeid)
			vm.fetchLoding = true
			this.axios
				.get('QuickReplyGroup/getQuickTree', {
					params: { typeid: typeid }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.quickTree = data.data
					}
					vm.fetchLoding = false
				})
		},
		close() {
			// this.reply = 'reply on'
			// this.$emit('quickReplyHide', false)
			this.$emit('close')
		},
		switchto(data) {
			if (data == 0) {
				this.tabclass1 = 'on'
				this.tabclass2 = ''
				this.getQuickGroups(1)
			} else {
				this.tabclass1 = ''
				this.tabclass2 = 'on'
				this.getQuickGroups(0)
			}
		},
		tag2Click(index) {
			this.updatetag('tag2Selected', index)
		},
		updatetag(key, index) {
			let vm = this
			var inde = vm[key].findIndex(d => d.index == index)
			if (inde > -1) {
				vm[key][inde].selected = !vm[key][inde].selected
			} else {
				vm[key].push({ index: index, selected: true })
			}
		},
		onSelected(val) {
			document.getElementById('charInput').append(val.content)
		},
		AddQuick() {
			this.$router
				.push({ path: '/customs/setting', query: { key: 'addQuick' } })
				.catch(err => {
					console.log(err)
				})
		},
		tag1Click(index) {
			this.updatetag('tag1Selected', index)
			console.log(this.tag1Selected)
		},
		renderContent(h, { node, data, store }) {
			return (
				<span class="custom-tree-node">
					<span>{node.label}</span>
				</span>
			)
		},
		NodeClisk(val) {
			this.$emit('openQuickList', val)
		}
	}
}
</script>
<style scoped>
/*快捷回复*/
.tablist {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
#addQuick:hover {
	cursor: pointer;
}
.tablist > div {
	width: 40%;
	text-align: center;
	border-bottom: 2px solid transparent;
}
.tablist > div.on {
	width: 40%;
	text-align: center;
	color: #409eff;
	border-bottom: 2px solid #409eff;
}
.words:hover {
	padding: 5px 20px;
	line-height: 20px;
	color: #666;
	background-color: #409eff;
	color: white;
}
.reply .el-input-group {
	padding: 0 5%;
	width: 90%;
	margin: 10px auto;
}
.words {
	padding: 5px 20px;
	line-height: 20px;
	color: #666;
}
.words.active {
	padding: 5px 20px;
	line-height: 20px;
	color: #666;
	background-color: #409eff;
	color: white;
}

.contains {
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
}
header {
	width: 100%;
	height: 60px;
	line-height: 60px;
	border-bottom: 1px solid #e1e3e6;
}
.tabs {
	list-style: none;
	height: 60px;
	line-height: 60px;
	padding-left: 30px;
	float: left;
}
.tabs li {
	float: left;
	width: 108px;
	height: 38px;
	line-height: 38px;
	text-align: center;
	margin-left: 15px;
	border-radius: 3px;
	margin-top: 11px;
	border: 1px solid #ddd;
	cursor: pointer;
}
.tabs li.on {
	background-color: #65a9e8;
	color: #fff;
	border: 1px solid #65a9e8;
}
.group {
	float: right;
	margin-right: 30px;
}
.search {
	float: right;
	margin-right: 21px;
}
.date {
	float: right;
	margin-right: 60px;
}
.select {
	background-color: transparent !important;
	min-width: 100px;
}
.date {
	width: 140px;
}
.search_box {
	float: left;
}

.dropmenu {
	float: left;
}
.dropmenu button {
	border-radius: 4px 0 0 4px !important;
	border-right: none;
}

.flex-title {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
} /*快捷回复*/
.tablist {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.tablist > div {
	width: 40%;
	text-align: center;
	border-bottom: 2px solid transparent;
}
.tablist > div.on {
	width: 40%;
	text-align: center;
	color: #409eff;
	border-bottom: 2px solid #409eff;
}
.reply .el-input-group {
	padding: 0 5%;
	width: 90%;
	margin: 10px auto;
}
.words {
	padding: 5px 30px;
	line-height: 20px;
	color: #666;
}
.words:hover {
	padding: 5px 20px;
	line-height: 20px;
	color: #666;
	cursor: pointer;
}
.list {
	padding: 4px 10px;
	cursor: pointer;
}
.contains {
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
}
header {
	width: 100%;
	height: 60px;
	line-height: 60px;
	border-bottom: 1px solid #e1e3e6;
}
.tabs {
	list-style: none;
	height: 60px;
	line-height: 60px;
	padding-left: 30px;
	float: left;
}
.tabs li {
	float: left;
	width: 108px;
	height: 38px;
	line-height: 38px;
	text-align: center;
	margin-left: 15px;
	border-radius: 3px;
	margin-top: 11px;
	border: 1px solid #ddd;
	cursor: pointer;
}
.tabs li.on {
	background-color: #65a9e8;
	color: #fff;
	border: 1px solid #65a9e8;
}
.group {
	float: right;
	margin-right: 30px;
}
.search {
	float: right;
	margin-right: 21px;
}
.date {
	float: right;
	margin-right: 60px;
}
.select {
	background-color: transparent !important;
	min-width: 100px;
}
.date {
	width: 140px;
}
.search_box {
	float: left;
}

.dropmenu {
	float: left;
}
.dropmenu button {
	border-radius: 4px 0 0 4px !important;
	border-right: none;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/quickReply.vue